//SET LOADING STATE

export const setLoadingIndicator = (isLoading) => ({
    type : 'SET_LOADING_INDICATOR',
    isLoading
});


// WEBPACK FOOTER //
// ./src/Actions/loading.js